<template>
  <div class="About">
    <div class="wrapper">
      <h1>About Me.</h1>
      <h2>Stay Passionate. Keep Pushing. Have Fun.</h2>
    
      <div class="mastImage">
        <img src="/assets/ui/about-masthead-1200.jpg" srcset="/assets/ui/about-masthead-600.jpg 600w, /assets/ui/about-masthead-1200.jpg 1200w, /assets/ui/about-masthead-2400.jpg 2400w" sizes="(max-width: 1200px) 100vw, 1200px">
      </div>
      <div class="intro">
        In addition to my extensive work as a Product and UX/UI Designer, I've broadened and honed my design skills through my work as a successful board game designer, and my previous work as an architect, and visual artist. That broad, holistic approach to my design practice is also reflected in my personal life. I am always striving to grow and learn more through diversity of experience. Travel, living abroad, adventuring in the wilds of the world, exploring the arts in other mediums; these all help me become a better person &mdash; and hence, a better designer.
      </div>
      
      <div class="cv">
        <div class="col">
          <h3>Product, UX/UI Design</h3>
          <ul>
            <li>Demographic and market analysis</li>
            <li>Revenue model and marketing strategy</li>
            <li>Writing business, functional and technical requirements</li>
            <li>Visual and Interaction design</li>
            <li>Wireframing/Prototyping; from quick, low res paper to fully interactive, high fidelity prototypes</li>
            <li>Flow diagrams, Story Boarding, Information Architecture</li>
            <li>Personas, User Journey Mapping and User Stories</li>
            <li>User interviews and Ethnographic research</li>
            <li>Usability testing and analysis</li>
          </ul>

          <h3>Leadership &amp; Growth</h3>
          <ul>
            <li>Planning and managing project timelines, deliverables and budgets</li>
            <li>Sourcing and hiring design and development talent</li>
            <li>Liaising with, and presenting to, executive and client stakeholders at all levels</li>
            <li>Managing and nuturing project teams (developers, designers and researchers)</li>
            <li>BusDev &amp; Growth experience; relationship building, customer acquisition, market share, and revenues</li>
          </ul>

          <h3>Front End Development</h3>
          <ul>
            <li>Hand-coding standards-compliant HTML, CSS and Javascript</li>
            <li>Deeply familiar with browser, platform and device quirks and differences</li>
            <li>Browser testing and UAT</li>
          </ul>

          <h3>Complimentary Skills</h3>
          <ul>
            <li>Well-versed with both Agile and Waterfall workflows</li>
            <li>Extensive experience with SaaS Platforms (B2C, B2B), Ecommerce, Internal business platforms and pipelines</li>
            <li>BusDev experience; growing relationships, teams, market share and revenues</li>
            <li>Leading discovery, ideation and design workshops</li>
            <li>Strong technical skills and understanding of tech-stacks and development considerations</li>
            <li>Highly motived by challenges and things I don’t know</li>
          </ul>

          <h3>Game Design &amp; Market Development</h3>
          <ul>
            <li>Game ideation, design, prototyping &amp; testing</li>
            <li>Marketing strategy (Kickstarter, conventions, advertising and influencers)</li>
            <li>Market analysis, forecasting, shipping logistics and manufacturing</li>
          </ul>
        </div>
        <div class="col two">
          <h3>Employment</h3>
          <ul>
            <li>
              <strong>2020 - Present</strong>
              Director of Product Design, Relish Studios &amp; Greyridge Games
            </li>
            <li><strong>2001 - 2020</strong>Principal, Coalescent Design</li>
            <li>
              <strong>2000 - 2002</strong>
              Sessional Instructor, Web Design, Langara College
            </li>
            <li>
              <strong>1998 - 2001</strong>
              Partner in Vancouver-based digital agency
            </li>
          </ul>

          <h3>Tools &amp; Tech</h3>
          <ul>
            <li>Figma</li>
            <li>Sketch</li>
            <li>Axure</li>
            <li>Adobe Products</li>
            <li>InVision</li>
            <li>Framer X</li>
            <li>Visual Studio Code</li>
            <li>Git</li>
            <li>Webpack</li>
            <li>VueJS</li>
            <li>ReactJS</li>
            <li>CSS/Sass/Less</li>
            <li>jQuery</li>
          </ul>

          <h3>Education</h3>
          <ul>
            <li>Bachelor of Visual Arts (Honours)</li>
            <li>Bachelor of Architecture (Honours)</li>
          </ul>
        </div>
      </div>
      <a href="https://www.dropbox.com/s/5qeymr6m9mn0qxl/Mike-Cassie-CV.pdf" target="_blank" class="download">Download CV</a>
    </div>
    <Footer />
  </div>
</template>

<script>
import Footer from '@/components/Footer.vue'

export default {
  name: 'About',
  components: {
    Footer
  },
}
</script>

<style lang="scss" scoped>
  .About {
    background: #fff;
    padding: 160px 0 0 0;

    & .wrapper {
      margin: 0 auto;
      width: 1200px;
      padding: 0 0 80px 0;

      @media screen and (max-width: 1200px) {
        width: calc(100% - 80px);
      }
      @media screen and (max-width: $breakSmall) {
        width: calc(100% - 40px);
      }
    }

    & h1 {
      margin: 0 0 60px 0;
      text-align: center;
    }
    & h2 {
      text-align: center;
    }

    & .mastImage {
      margin: 60px auto;
      width: 1200px;
      animation: loadContent 500ms 600ms forwards;
      opacity: 0;

      @keyframes loadContent {
        from {opacity: 0;}
        to {opacity: 1;}
      }

      & img {
        display: block;
        width: 100%;
        height: auto;
      }

      @media screen and (max-width: 1240px) {
        width: 100%;
      }
    }
    & .intro {
      text-align: center;
      font-size: 20px;
      line-height: 40px;

      @media screen and (max-width: $breakSmall) {
        font-size: 18px;
        line-height: 36px;
      }
    }
    & .download {
      display: block;
      width: 140px;
      padding: 10px 0;
      border: 1px solid #000;
      text-transform: uppercase;
      text-align: center;
      margin: 60px auto 0 auto;
      @include fontBodyBold;
      font-size: 14px;
      text-decoration: none;

      &:hover {
        border-color: $linkColorActive;
      }
    }
    & .cv {
      margin: 60px 0 0 0;
      display: flex;
      justify-content: space-between;

      & .col {
        width: 60%;

        & h3 {
          margin: 60px 0 30px 0;
          padding: 0 0 10px 0;
          border-bottom: 1px solid #000;
        }
        &.two {
          width: 25%;
          // border-left: 1px solid #000;
          // padding: 0 0 0 40px;

          // & h3 {
          //   @include fontBodyBold;
          //   font-size: 16px;
          //   text-transform: uppercase;
          //   border: none;
          //   padding: 0;
          //   margin: 60px 0 20px 0;
          // }
        }
      }
      & ul {
        list-style: none;
        padding: 0 0 0 10px;

        & li {
          padding: 5px 0 4px 20px;
          position: relative;

          &:before {
            content: '';
            display: block;
            width: 4px;
            height: 4px;
            border-radius: 4px;
            border: 1px solid #000;
            position: absolute;
            left: 0;
            top: 18px;
          }
          & strong {
            display: block;
          }
        }
      }
      @media screen and (max-width: $breakLarge) {
        & .col {
          width: 55%;

          &.two {
            width: 35%;
          }
        }
      }
      @media screen and (max-width: $breakSmall) {
        flex-direction: column;
        margin: 0;
        & .col {
          width: 100%;

          &.two {
            width: 100%;
          }
        }
      }
    }
    @media screen and (max-width: $breakSmall) {
      & .wrapper {
        padding: 0 0 40px 0;
      }
    }
  }
</style>